<template>
  <HKLModal
    ref="rejectModal"
    class="wp-reject-extension-modal"
    :title="$t('workPermit.rejctExtensionHint')"
    okBtnAction="rejectAction"
    :okBtnDisabled="isCommentEmpty"
    :afterClose="resetData"
    @onOkClick="rejectExtension"
  >
    <TextField
      :label="$t('comment')"
      :showColon="false"
      :required="true"
      :value="rejectComments"
      :placeholder="$t('hint.typeRejectComment')"
      @inputValue="updateComment"
    />
  </HKLModal>
</template>

<script>
import _ from 'lodash'
import { mapActions, mapGetters } from 'vuex'

import HKLModal from '@/controls/Modal/HKLModal'
import TextField from '@/controls/TextField'
import { rejectExtensionWorkPermit } from '@/api/workPermit/request'
import { utils as formUtils } from '@/plugin/InputChange'
import { EmailTypes } from '@/utils/consts'
import { sendEmail } from '@/api/postman/request'

export default {
  components: {
    HKLModal,
    TextField,
  },
  data () {
    return {
      rejectComments: '',
    }
  },
  computed: {
    ...mapGetters('workPermit', ['currentWorkPermit']),
    isCommentEmpty () {
      return _.isEmpty(this.rejectComments)
    },
  },
  methods: {
    ...mapActions('workPermit', ['getWorkPermitById']),
    updateComment (val) {
      this.rejectComments = _.trim(val)
    },
    open () {
      this.$refs.rejectModal.open()
    },
    validate () {
      return !this.isCommentEmpty
    },
    async rejectExtension () {
      try {
        await rejectExtensionWorkPermit(this.currentWorkPermit.id, { rejectReason: this.rejectComments })
        await this.getWorkPermitById(this.currentWorkPermit.id)
        await sendEmail(EmailTypes.workPermits.rejectExtensionWP, this.currentWorkPermit)
      } catch (error) {
        console.error(error)
      } finally {
        this.resetData()
      }
    },
    resetData () {
      this.rejectComments = ''
      formUtils.resetDirty()
    },
  },
}
</script>
<style lang="scss" scoped>
.wp-reject-extension-modal {
  & ::v-deep {
    textarea {
      width: 100%;
    }
  }
}
</style>
